import { RootState } from 'types'
import { WizardTourDismissalAction } from 'redux/actions'
import { WizardTourDismissalActions } from 'redux/actions/wizardTourDismissals'

export default function reduce(
  state: RootState['wizardTourDismissals'] = [],
  { type, payload }: WizardTourDismissalAction,
): RootState['wizardTourDismissals'] {
  if (type === WizardTourDismissalActions.SET_WIZARD_TOUR_DISMISSALS) {
    return [...(payload.names || [])]
  }

  if (!payload?.name) {
    return state
  }

  if (type === WizardTourDismissalActions.CREATE_WIZARD_TOUR_DISMISSAL) {
    return [...state, payload.name]
  }

  return state
}
